let isPrerender = window.__PRERENDER_INJECTED__ && window.__PRERENDER_INJECTED__.prerender
let page_name = window.__PRERENDER_INJECTED__ && window.__PRERENDER_INJECTED__.page_name
// if (process.env.NODE_ENV === 'production') {
//   __webpack_public_path__ = isPrerender
//     ? ''
//     : `//cdn.jiguo.com/special/${window.__page_name__}/`
// }
